import { useState, useEffect } from 'react';
import { getroledata } from 'service/myapi';

const usePermissions = () => {
    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
      };
    
      const myrole = getCookie('userType');
      const [allpermission, setpermission] = useState([]);
      const [isAdmin, setIsAdmin] = useState(false);    

      //console.log('sst',allpermission);
      
      useEffect(() => {
        if (myrole === 'admin') {
          setIsAdmin(true);
        } else {
          getallroles();
        }
      }, []);
    
      const getallroles = async () => {
        try {
          const response = await getroledata(myrole);
          const permissions = response.data.role.permissions;
          const truePaths = permissions
            .filter(permission => permission.value)
            .map(permission => permission.path.replace(/^\//, ''));
          setpermission(truePaths);
        } catch (error) {
          console.error('Error fetching roles:', error);
        }
      };
      return { allpermission, isAdmin };
};

export default usePermissions;
